'use client';
import React from 'react';
import { AppStoreNames } from './footerEntity';
import styles from './NewAppStoreButton.module.scss';

interface Props {
  icon: React.ReactElement;
  name: AppStoreNames;
  storeUrl: string;
}

const NewAppStoreButton: React.FC<Props> = ({ icon, name, storeUrl }) => {
  const dataAction =
    name === 'apple-app-store' ? 'Download on Apple App Store Click' : 'Download on Google Play Store Click';

  return (
    <a
      aria-label="Click to download the Benzinga app"
      className={`${styles.buttonWrapper} ${name}-button-wrapper button-wrapper`}
      data-action={dataAction}
      href={storeUrl}
    >
      {icon}
    </a>
  );
};

export default NewAppStoreButton;
